module.exports = __webpack_public_path__ + "img/ecole-maimonides.3b900d8c.webp";